export const PDF_EXTENSIONS = [".pdf"];
